import React, { ReactNode } from 'react';
import {
   Popover,
   PopoverTrigger,
   PopoverContent,
   PopoverBody,
   PopoverArrow,
   ButtonProps,
   PopoverContentProps,
} from '@chakra-ui/react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FilterButton } from './FilterButton';

type PopoverFilterProps = ButtonProps & {
   label: string;
   ariaLabel: string;
   children: ReactNode;
   selected?: number | boolean;
   contentProps?: PopoverContentProps;
};

export const PopoverFilter = ({
   label,
   children,
   ariaLabel,
   selected = 0,
   contentProps,
   ...buttonProps
}: PopoverFilterProps) => (
   <Popover>
      <PopoverTrigger>
         <FilterButton label={label} icon={faChevronDown} selected={selected} {...buttonProps} />
      </PopoverTrigger>
      <PopoverContent maxW="150px" aria-label={ariaLabel} {...contentProps}>
         <PopoverArrow />
         <PopoverBody>{children}</PopoverBody>
      </PopoverContent>
   </Popover>
);
